import AuthSkeleton from "../../common/authSkeleton/authSkeleton";

/* Team invite: phone + 2 passwords stacked, plus the name row. */
const RegisterStaffSkeleton = () => <AuthSkeleton fields={3} rows={1} />;

export default RegisterStaffSkeleton;
